__turbopack_context__.v({
  "tab": "Content-module-scss-module__u8Skha__tab",
  "tabs": "Content-module-scss-module__u8Skha__tabs",
  "tabsWrapper": "Content-module-scss-module__u8Skha__tabsWrapper",
});
